


































































































import { Component } from 'vue-mixin-decorator';

import BaseView from '@/views/BaseView.vue';
import ExamFooter from '@/components/ExamFooter.vue';
import ExamGuide from '@/components/ExamGuide.vue';
import ExamNav from '@/components/ExamNav.vue';
import IndicatorModal from '@/components/IndicatorModal.vue';

import RepositoryFactory from '@/repository/RepositoryFactory';

import * as StringUtil from '@/common/StringUtil';

import SettlementCartHistory from '@/models/entry/SettlementCartHistory';
import SettlementCartHistoryItem from '@/models/entry/SettlementCartHistoryItem';

@Component(
  {
    components: {
      'e-footer': ExamFooter,
      'e-guide': ExamGuide,
      'e-nav': ExamNav,
      'e-indicator': IndicatorModal,
    },
  },
)
export default class History extends BaseView {
  private isIndicatorDisplay = false;

  private examTitle = '';

  private settlementCartHistoryList: SettlementCartHistory[] = [];

  private ExamRepository = RepositoryFactory.get().exam;

  private EntryRepository = RepositoryFactory.get().entry;

  private async mounted() {
    this.isIndicatorDisplay = true;

    const CommonCss = document.createElement('link');
    CommonCss.rel = 'stylesheet';
    CommonCss.href = '/css/common.css';
    this.$el.appendChild(CommonCss);

    const HistoryCss = document.createElement('link');
    HistoryCss.rel = 'stylesheet';
    HistoryCss.href = '/account/css/history.css';
    this.$el.appendChild(HistoryCss);

    const GoodsListCss = document.createElement('link');
    GoodsListCss.rel = 'stylesheet';
    GoodsListCss.href = '/css/goods/css/goods_list.css';
    this.$el.appendChild(GoodsListCss);

    this.getExamConfigCss().then((cssElement: HTMLLinkElement) => {
      this.$el.appendChild(cssElement);
    });

    try {
      await this.getExamInfo();
      await this.getHistory();
    } catch (e) {
      this.$router.replace(this.paths.LOGIN);
    } finally {
      this.isIndicatorDisplay = false;
    }

    const CommonJs = document.createElement('script');
    CommonJs.src = '/js/common.js';
    this.$el.appendChild(CommonJs);
  }

  /**
   * 検定情報の取得
   */
  async getExamInfo() {
    // 検定情報APIを呼び出し、検定タイトルを取得
    this.ExamRepository.getExam().then((response) => {
      if (response.status === 200) {
        this.examTitle = response.data.exam_title;
      }
    });
  }

  /**
   * 購入履歴の取得
   */
  async getHistory() {
    // 購入履歴の取得
    await this.EntryRepository.getSettlementCartHistory().then((response) => {
      if (response.status !== 200 || response.data.histories === undefined) {
        return;
      }
      let settlementCartHistories: SettlementCartHistory[];
      try {
        settlementCartHistories = this.EntryRepository.convert.deserialize(response.data.histories, SettlementCartHistory) as Array<SettlementCartHistory>;
      } catch (e) {
        // this.$router.replace({ path: this.paths.TOP });
        return;
      }
      // 表示用に変換
      for (let historyIndex = 0; historyIndex < settlementCartHistories.length; historyIndex += 1) {
        const history = settlementCartHistories[historyIndex];
        history.settlementDate = StringUtil.toJapanDateString(history.settlementDate, 'YYYY/MM/DD');
        for (let itemIndex = 0; itemIndex < history.cartHistoryItems.length; itemIndex += 1) {
          const item = history.cartHistoryItems[itemIndex];
          item.goodsCode = String(item.goodsCode);
          item.rankCode = String(item.rankCode);
          for (let entryIndex = 0; entryIndex < item.entries.length; entryIndex += 1) {
            const entry = item.entries[entryIndex];
            for (let resultIndex = 0; resultIndex < entry.results.length; resultIndex += 1) {
              const result = entry.results[resultIndex];
              result.examinationDatetime = StringUtil.toJapanDateString(result.examinationDatetime, 'YYYY/MM/DD');
            }
          }
        }
      }

      this.settlementCartHistoryList = settlementCartHistories;
    });
  }

  /**
   * 詳細へ。
   * @param item 購入履歴アイテム
   */
  private transitionSettlementHistoryDetail(item: SettlementCartHistoryItem) {
    if (item.isGoods) {
      this.$router.replace(`${this.paths.GOODS_DETAIL}?goods_code=${StringUtil.encodeToBase64Url(item.goodsCode)}`);
    } else {
      this.$router.replace(`${this.paths.KENTEI_DETAIL}?rank=${StringUtil.encodeToBase64Url(item.rankCode)}`);
    }
  }

  /**
   * 検定開始に遷移します。
   *
   * @param ランクコード（生コド）
   * @param 受験申込コード
   */
  private transitionExamReady(rankCode: string, entryCode: string) {
    // eslint-disable-next-line @typescript-eslint/camelcase
    this.$router.replace({ path: this.paths.EXAM_READY, query: { rank: this.encodeToBase64Url(rankCode), examination_entry_code: entryCode, is_callback: '0' } });
  }

  // eslint-disable-next-line class-methods-use-this
  encodeToBase64Url(str: string): string {
    return StringUtil.encodeToBase64Url(str);
  }

  // eslint-disable-next-line class-methods-use-this
  isEmpty(str: any): boolean {
    return StringUtil.isEmpty(str);
  }

  // eslint-disable-next-line class-methods-use-this
  formatPrice(amount: number): string {
    return StringUtil.separateNumber(amount);
  }

  // eslint-disable-next-line class-methods-use-this
  formatSettlementStatus(settlementStatus: string): string {
    if (settlementStatus === 'unpaid') {
      return '未決済';
    }
    if (settlementStatus === 'paid') {
      return '決済完了';
    }
    return settlementStatus;
  }
}
